import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
		path: '/login',
		component: () => import('@/views/login/index'),
		hidden: true
	},
	{
		path: '/404',
		component: () => import('@/views/404'),
		hidden: true
	},
	{
		path: '/screen',
		component: () => import('@/views/statistics/screen'),
		name: 'admin:screen',
		meta: {
			title: '数据大屏',
			icon: 'product'
		}
	},
	{
		path: '',
		component: Layout,
		redirect: '/home',
		children: [{
			path: 'home',
			name: 'home',
			component: () => import('@/views/home/index'),
			meta: {
				title: '首页',
				icon: 'home'
			}
		}]
	},
	{
		path: '/largeScreen',
		component: Layout,
		name: 'admin:largeScreen',
		redirect: '/screen',
		meta: {
			title: '统计管理',
			icon: 'screen'
		},
		children: [{
			path: 'screen',
			component: () => import('@/views/statistics/largeScreen'),
			name: 'admin:screen',
			meta: {
				title: '统计管理',
				icon: 'screen'
			}
		}]
	}
]

export const asyncRouterMap = [{
		path: '/productManage',
		component: Layout,
		redirect: '/productManage/list',
		name: 'admin:productManage',
		meta: {
			title: '产品管理',
			icon: 'productManage'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'admin:productManage:list',
			component: () => import('@/views/productManage/list'),
			meta: {
				title: '产品列表',
				icon: ''
			}
		}]
	},
	{
		path: '/deviceManage',
		component: Layout,
		redirect: '/deviceManage/list',
		name: 'admin:deviceManage',
		meta: {
			title: '设备管理',
			icon: 'deviceManage'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'admin:deviceManage:list',
			component: () => import('@/views/deviceManage/list'),
			meta: {
				title: '设备列表',
				icon: ''
			}
		}]
	},
	{
		path: '/adminUser',
		component: Layout,
		redirect: '/adminUser/list',
		name: 'admin:admin',
		meta: {
			title: '系统用户',
			icon: 'order'
		},
		alwaysShow: true,
		children: [{
				path: 'dept',
				name: 'admin:dept:list',
				component: () => import('@/views/adminUser/dept'),
				meta: {
					title: '部门管理',
					icon: 'product-list'
				}
			},
			{
				path: 'list',
				name: 'admin:admin:list',
				component: () => import('@/views/adminUser/list'),
				meta: {
					title: '用户列表',
					icon: 'product-list'
				}
			},
			{
				path: 'update',
				name: 'admin:admin:add',
				component: () => import('@/views/adminUser/update'),
				meta: {
					title: '更新系统用户',
					icon: 'product-add'
				},
				hidden: true
			}
		]
	},
	{
		path: '/role',
		component: Layout,
		redirect: '/role/list',
		name: 'admin:role',
		meta: {
			title: '角色管理',
			icon: 'sms'
		},
		alwaysShow: true,
		children: [{
				path: 'list',
				name: 'admin:role:list',
				component: () => import('@/views/role/list'),
				meta: {
					title: '角色列表',
					icon: 'sms-flash'
				}
			},
			{
				path: 'update',
				name: 'admin:role:add',
				component: () => import('@/views/role/update'),
				meta: {
					title: '更新角色',
					icon: 'product-add'
				},
				hidden: true
			}
		]
	},
	{
		path: '/config',
		component: Layout,
		redirect: '/config/list',
		name: 'admin:config',
		meta: {
			title: '配置管理',
			icon: 'ums'
		},
		alwaysShow: true,
		children: [{
				path: 'list',
				name: 'admin:config:list',
				component: () => import('@/views/config/list'),
				meta: {
					title: '配置列表',
					icon: 'ums-admin'
				}
			},
			{
				path: 'update',
				name: 'admin:config:add',
				component: () => import('@/views/config/update'),
				meta: {
					title: '更新',
					icon: 'ums-admin'
				},
				hidden: true
			}
		]
	},
	{
		path: '/adminLog',
		component: Layout,
		redirect: '/adminLog/list',
		name: 'admin:log',
		meta: {
			title: '日志管理',
			icon: 'ums'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'admin:log:list',
			component: () => import('@/views/adminLog/list'),
			meta: {
				title: '日志列表',
				icon: 'ums-admin'
			}
		}]
	},
	{
		path: '*',
		redirect: '/404',
		hidden: true
	}
]

export default new Router({
	mode: 'history', //后端支持可开
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js